import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

/**
 * Admin Console entry point.
 * Renders the App in StrictMode for development-time checks.
 */
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Ensure index.html has a <div id="root">.');
}

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
